const CHOOSE_FROM_DEVICE_INSTEAD = "choose a photo from your device instead.";

const errorName = (error: unknown): string => {
    if (typeof error !== "object" || error === null || !("name" in error)) {
        return "";
    }
    return typeof error.name === "string" ? error.name : "";
};

export const describeCameraAccessError = (error: unknown): string => {
    switch (errorName(error)) {
        case "NotAllowedError":
        case "PermissionDeniedError":
        case "SecurityError":
            return `Camera access was blocked. Allow camera access for this site in your browser, or ${CHOOSE_FROM_DEVICE_INSTEAD}`;
        case "NotFoundError":
        case "DevicesNotFoundError":
        case "OverconstrainedError":
            return `No camera was found on this device. Please ${CHOOSE_FROM_DEVICE_INSTEAD}`;
        case "NotReadableError":
        case "TrackStartError":
        case "AbortError":
            return `The camera is already in use or couldn't be started. Close other apps that use the camera and try again, or ${CHOOSE_FROM_DEVICE_INSTEAD}`;
        default:
            return `We couldn't start the camera. Please ${CHOOSE_FROM_DEVICE_INSTEAD}`;
    }
};
